(function () {
  window.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll('.js-slideshow__section');
    Array.prototype.forEach.call(sliders, function(slider) {
      const slides = slider.querySelectorAll('.js-slideshow__slide');
      Array.prototype.forEach.call(slides, function(slide) {
        if (slide.dataset.backgroundPc && slide.dataset.backgroundMobile === '') {
          slide.style.cssText = `background-image:url(${slide.dataset.backgroundPc});background-position:${slide.dataset.backgroundPositionPc};`;
        } else if (slide.dataset.backgroundPc  === '' && slide.dataset.backgroundMobile === '') {
          slide.style.cssText = `background-position:${slide.dataset.backgroundPositionMobile};`;
        }
        else {
          let mobile = window.matchMedia('(min-width:0px) and (max-width:989px)');
          let desktop = window.matchMedia('(min-width:990px)');
          /* On Load */
          window.addEventListener('load', function() {
            if(mobile.matches) {
              slide.style.cssText = `background-image:url(${slide.dataset.backgroundMobile});background-position:${slide.dataset.backgroundPositionMobile};`;
            }
            else if(desktop.matches) {
              slide.style.cssText = `background-image:url(${slide.dataset.backgroundPc});background-position:${slide.dataset.backgroundPositionPc};`;
            }
          });
          /* On Resize */
          window.addEventListener('resize', function() {
            if(mobile.matches) {
              slide.style.cssText = `background-image:url(${slide.dataset.backgroundMobile});background-position:${slide.dataset.backgroundPositionMobile};`;
            }
            else if(desktop.matches) {
              slide.style.cssText = `background-image:url(${slide.dataset.backgroundPc});background-position:${slide.dataset.backgroundPositionPc};`;
            }
          });
        }
      });
    });
  });
})();